<template>
  <div class="layout-header">
    <div class="layout-header-start">
      <div
        class="layout-header-start-menu-icon"
        @click="showMenu"
        v-html="isMenuMini ? iconMenuOpen : iconMenuClose"
      />
      <div
        class="layout-header-start-logo"
        @click="home"
        v-html="iconLogo"
      />
    </div>
    <div class="layout-header-middle">
      <slot name="middle" />
    </div>
    <div class="layout-header-end layout-header-end--desktop">
      <div
        class="layout-header-end-ava"
        @click="user"
        v-html="iconAva"
      />
      <div
        class="layout-header-end-exit"
        @click="exit"
        v-html="iconExit"
      />
    </div>
    <div class="layout-header-end layout-header-end--mobile">
      <q-btn
        flat
        round
        dense
        icon="menu"
        @click="$emit('mobile-menu-click', $event)"
      />
    </div>
  </div>
</template>

<script>
/**
 * Header
 * @module Layout/Component/Header
 * @requires vuex
 * @requires Layout
 * @requires Utils/notify
 * */
import iconMenuOpen from 'Images/icon/menu-close.svg'
import iconMenuClose from 'Images/icon/menu-opened.svg'
import iconLogo from 'Images/icon/logo.svg'
import iconAva from 'Images/icon/ava.svg'
import iconExit from 'Images/icon/exit.svg'
import { notify } from 'Utils/notify'
import { AuthenticationService } from '../../../api/auth'

export default {
  name: 'VueLayoutHeader',
  props: {
    isMenuMini: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    iconMenuOpen,
    iconMenuClose,
    iconLogo,
    iconAva,
    iconExit,
    authService: new AuthenticationService()
  }),
  methods: {
    /**
     * Log out - удаляет из LocalStorage токены
     * @function
     * */
    exit() {
      this.authService.logout()
      this.$router.push({path:'/auth'})
    },
    /**
     * Переход на главную страницу
     * @function
     * */
    home() {
      this.$router.push({path:'/'})
    },
    /**
     * Заглушка для перехода на страницу пользователя
     * @function
     * */
    user() {
      notify({
        text: 'User'
      })
    },
    /**
     * Запускает событие на открытие десктопного бокового меню
     * @function
     * */
    showMenu(e) {
      this.$emit('mini-click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-header {
  width: 100%;
  height: var(--header-height);
  background-color: $color-white;
  display: flex;
  justify-content: flex-start;

  .layout-header-start {
    width: var(--menu-width);
    display: flex;
    align-items: center;
    padding: 0 24px;

    &-menu-icon {
      cursor: pointer;
      width: 24px;
      height: 24px;
    }

    &-logo {
      cursor: pointer;
      margin-left: 24px;
      width: 36px;
      height: 36px;
    }

    &-menu-icon:hover,
    &-logo:hover {
      opacity: 0.6;
    }
  }

  .layout-header-middle {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: var(--container-x-padding);
    flex-grow: 1;

    button {
      white-space: nowrap;
      height: 44px;
      margin-right: 24px;
    }
  }

  .layout-header-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    &-ava {
      cursor: pointer;
      width: 33px;
      height: 33px;
      margin-right: 24px;
    }

    &-exit {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin-right: 24px;
    }

    &-ava:hover,
    &-exit:hover {
      opacity: 0.6;
    }

    &.layout-header-end--mobile {
      display: none;
      color: $color-light-blue-2;
    }
  }

  @media screen and (max-width: $breakpoint-sm-max) {
    padding: 0 var(--container-x-padding);

    .layout-header-start {
      padding: 0;

      &-menu-icon {
        display: none;
      }

      &-logo {
        margin-left: 0;
      }
    }

    .layout-header-end {
      &.layout-header-end--desktop {
        display: none;
      }

      &.layout-header-end--mobile {
        display: flex;
      }
    }

    .layout-header-middle {
      padding-left: 20px;

      button {
        margin-right: 16px;
      }
    }
  }

  @media screen and (max-width: $breakpoint-xs-max) {
    justify-content: space-between;
    padding: 0 15px;

    .layout-header-middle {
      display: none;
    }
  }
}
</style>
